<svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">

<rect width="36" height="36" rx="10" fill="#F5F6F9"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M9 12C9 10.8954 9.89543 10 11 10H25C26.1046 10 27 10.8954 27 12V26C27 27.1046 26.1046 28 25 28H11C9.89543 28 9 27.1046 9 26V12Z" stroke="#7586B0" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M22 8V12" stroke="#7586B0" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M14 8V12" stroke="#7586B0" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M9 16H27" stroke="#7586B0" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<defs>
<linearGradient id="paint0_linear_45_8861" x1="35.0204" y1="1.22449" x2="0" y2="36" gradientUnits="userSpaceOnUse">
<stop stop-color="#56ACF6"/>
<stop offset="1" stop-color="#1559E6"/>
</linearGradient>
</defs>
</svg>
